export default function AuthToken(currentDate) {
    const expirationTime = parseInt(sessionStorage.getItem("expiresInSeconds")) * 1000; //Expiration Time in milliseconds
    const loggedInTime = parseInt(sessionStorage.getItem("loggedInTime"));

    //Check token validity
    return currentDate.getTime() - loggedInTime < expirationTime;
}